import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '@/app/store'

type dialogRewardsGetState = {
  boolean: boolean
  bad: boolean
}

const initialState: dialogRewardsGetState = {
  boolean: true,
  bad: true,
}

const dialogRewardsGetReducer = createSlice({
  name: 'dialogRewardsGet',
  initialState: initialState,
  reducers: {
    dialogRewardsGetState(state, action) {
      state.boolean = action.payload
    },
    dialogRewardsBadState(state, action) {
      state.bad = action.payload
    },
  },
})

export const { dialogRewardsGetState, dialogRewardsBadState } =
  dialogRewardsGetReducer.actions

export const selectOsakaPlace = (state: RootState) =>
  state.dialogRewardsGet.boolean
export const selectbad = (state: RootState) => state.dialogRewardsGet.bad

export default dialogRewardsGetReducer.reducer
